var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0634 5.03333C20.0643 4.93658 20.0268 4.8434 19.9592 4.7741L16.2926 1.10743C16.2236 1.03942 16.1302 1.00192 16.0333 1.0033V1H5.03335C4.42583 1 3.93335 1.49248 3.93335 2.1V21.9C3.93335 22.5075 4.42583 23 5.03335 23H18.9667C19.5742 23 20.0667 22.5075 20.0667 21.9V5.03333H20.0634ZM16.4 2.2518L18.8149 4.66667H16.7667C16.5642 4.66667 16.4 4.50249 16.4 4.3V2.2518ZM19.3334 21.9C19.3334 22.1025 19.1692 22.2667 18.9667 22.2667H5.03335C4.83086 22.2667 4.66668 22.1025 4.66668 21.9V2.1C4.66668 1.89751 4.83086 1.73333 5.03335 1.73333H15.6667V4.3C15.6667 4.90752 16.1592 5.4 16.7667 5.4H19.3334V21.9Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 10.8999C6.99248 10.8999 6.5 11.3924 6.5 11.9999C6.5 12.6074 6.99248 13.0999 7.6 13.0999C8.20752 13.0999 8.7 12.6074 8.7 11.9999C8.7 11.3924 8.20752 10.8999 7.6 10.8999ZM7.6 12.3666C7.39751 12.3666 7.23333 12.2024 7.23333 11.9999C7.23333 11.7974 7.39751 11.6332 7.6 11.6332C7.80249 11.6332 7.96667 11.7974 7.96667 11.9999C7.96667 12.2024 7.80249 12.3666 7.6 12.3666Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 11.6333H10.1667V12.3666H17.5001V11.6333Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 7.2334C6.99248 7.2334 6.5 7.72588 6.5 8.3334C6.5 8.94092 6.99248 9.4334 7.6 9.4334C8.20752 9.4334 8.7 8.94092 8.7 8.3334C8.7 7.72588 8.20752 7.2334 7.6 7.2334ZM7.6 8.70007C7.39751 8.70007 7.23333 8.53589 7.23333 8.3334C7.23333 8.13091 7.39751 7.96673 7.6 7.96673C7.80249 7.96673 7.96667 8.13091 7.96667 8.3334C7.96667 8.53589 7.80249 8.70007 7.6 8.70007Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 7.9668H10.1667V8.70013H17.5001V7.9668Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 14.5669C6.99248 14.5669 6.5 15.0594 6.5 15.6669C6.5 16.2744 6.99248 16.7669 7.6 16.7669C8.20752 16.7669 8.7 16.2744 8.7 15.6669C8.7 15.0594 8.20752 14.5669 7.6 14.5669ZM7.6 16.0336C7.39751 16.0336 7.23333 15.8694 7.23333 15.6669C7.23333 15.4644 7.39751 15.3002 7.6 15.3002C7.80249 15.3002 7.96667 15.4644 7.96667 15.6669C7.96667 15.8694 7.80249 16.0336 7.6 16.0336Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 15.2998H10.1667V16.0331H17.5001V15.2998Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6 18.2334C6.99248 18.2334 6.5 18.7259 6.5 19.3334C6.5 19.9409 6.99248 20.4334 7.6 20.4334C8.20752 20.4334 8.7 19.9409 8.7 19.3334C8.7 18.7259 8.20752 18.2334 7.6 18.2334ZM7.6 19.7001C7.39751 19.7001 7.23333 19.5359 7.23333 19.3334C7.23333 19.1309 7.39751 18.9667 7.6 18.9667C7.80249 18.9667 7.96667 19.1309 7.96667 19.3334C7.96667 19.5359 7.80249 19.7001 7.6 19.7001Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5001 18.9668H10.1667V19.7001H17.5001V18.9668Z",
    fill: "#4D4D4D",
    stroke: "#4D4D4D",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white",
    transform: "translate(3 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenu);
export default __webpack_public_path__ + "static/media/DashboardMenu.c43315d4a6ed2e55abe1e036fd37cebf.svg";
export { ForwardRef as ReactComponent };